export enum AuditStatusEnum {
  IN_PROGRESS = 'IN_PROGRESS',
  READY = 'READY',
}
